import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FormControlLabel } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import styled from 'styled-components';

interface WrapperProps {
  alignSelf?: string;
  hasError?: boolean;
}

const Wrapper = styled(FormControlLabel)<WrapperProps>`
  align-self: ${(props) => props.alignSelf ?? 'flex-start'};

  & .MuiTypography-root {
    font-size: 12px;
    font-weight: bold;
    color: #666;
  }

  & .MuiCheckbox-root {
    color: ${(props) =>
      props.hasError ? 'var(--require-border)' : 'var(--checkbox-border)'};
  }

  & .MuiSvgIcon-root {
    height: 22px;
  }

  & .Mui-checked .MuiSvgIcon-root {
    fill: var(--cargill-green);
  }
`;

type Customer = {
  id?: string;
};

type Store = {
  customer?: Customer;
};

type HandleOnChangePayload = {
  value: boolean;
  field: string;
  hcId: string;
  dispatch: Dispatch;
  apiService: ApiService;
  cardId?: string;
  required: boolean;
  t: (key: string) => string;
};

type Dispatch = (...args: never[]) => void;

/**
 * Define minimal shape instead of `unknown`
 * Extend this later if needed
 */
type ApiService = {
  [key: string]: (...args: never[]) => Promise<unknown> | unknown;
};

interface CheckboxComponentProps {
  name: string;
  label: string;
  hasGroupError?: boolean;
  checked?: boolean;
  alignSelf?: string;
  dispatch: Dispatch;
  cardId?: string;
  apiService: ApiService;
  store: Store;
  handleOnChange: (type: string, payload: HandleOnChangePayload) => void;
}

function CheckboxComponent({
  name,
  label,
  hasGroupError,
  checked,
  alignSelf,
  dispatch,
  cardId,
  apiService,
  store,
  handleOnChange
}: CheckboxComponentProps) {
  const [value, setValue] = useState<boolean | undefined>(checked);
  const { t } = useTranslation();

  const handleChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const {
      customer: { id: hcId = '' } = {}
    } = store;

    const isChecked = event.target.checked;

    setValue(isChecked);

    handleOnChange('transaction', {
      value: isChecked,
      field: name,
      hcId,
      dispatch,
      apiService,
      cardId,
      required: true,
      t
    });
  };

  useEffect(() => {
    setValue(checked);
  }, [checked]);

  return (
    <Wrapper
      alignSelf={alignSelf}
      label={label}
      hasError={hasGroupError}
      control={
        <Checkbox
          name={name}
          color="default"
          checked={value || false}
          onChange={handleChange}
        />
      }
    />
  );
}

export default CheckboxComponent;